import './Survay.css';
import React from "react";
import { Button } from "@material-ui/core";

export default function Survey() {
  return (
    <div className="beta-notice">
      <span>Let us know what your experience is with the new brand renewal system. &nbsp;</span>
      <Button
        onClick={() => window.location.href = 'https://www.surveymonkey.com/r/BrandRenewPrototypeFeedback'}
        className="feedback"
        variant="contained"
        color="secondary"
        data-id="HE2Ib"
      >
        Let us have it!
      </Button>
    </div>
  );
}
